import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { useSiteData } from '../contexts/SiteDataContext';

const fallbackTestimonials = [
  { name: "Carlos Eduardo Silva", role: "Proprietário - Oficina Hidráulica Maquinatech", location: "Ribeirão Preto - SP", text: "A TerraHydro resolveu um problema crítico que tínhamos há semanas. Enviamos foto de uma bomba antiga e em 2 horas já tínhamos a identificação correta e a peça disponível. Profissionalismo excepcional.", rating: 5 },
  { name: "Roberto Martins", role: "Gerente de Manutenção", location: "Goiânia - GO", text: "Trabalho com hidráulica há 20 anos e a TerraHydro é referência em qualidade e atendimento técnico. Sempre encontro as peças certas, com especificações completas e entrega rápida.", rating: 5 },
  { name: "Ana Paula Costa", role: "Engenheira Mecânica - AgroSul Equipamentos", location: "Uberlândia - MG", text: "O suporte técnico é diferenciado. Eles não apenas vendem a peça, mas ajudam a entender a aplicação e garantem compatibilidade total. Isso evita erro e economia no final.", rating: 5 }
];

const Testimonials = () => {
  const { pageContents } = useSiteData();
  const data = pageContents.testimonials || {};
  const items = data.metadata?.items || fallbackTestimonials;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#055509] mb-4">{data.title || 'O Que Dizem Nossos Clientes'}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">{data.subtitle || 'Confiança construída através de resultados e relacionamentos duradouros'}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {items.map((testimonial, idx) => (
            <Card key={idx} className="hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-[#FFB025] bg-white relative overflow-hidden">
              <div className="absolute top-4 right-4 opacity-5"><Quote size={80} className="text-[#055509]" /></div>
              <CardContent className="p-8 relative z-10">
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating || 5)].map((_, i) => (
                    <Star key={i} size={18} className="fill-[#FFB025] text-[#FFB025]" />
                  ))}
                </div>
                <p className="text-gray-700 leading-relaxed mb-6 italic">"{testimonial.text}"</p>
                <div className="border-t border-gray-100 pt-4">
                  <div className="font-bold text-[#055509]">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                  <div className="text-sm text-[#FFB025] font-semibold mt-1">{testimonial.location}</div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
